document.addEventListener('DOMContentLoaded', function () {
  function moveGalleryAccordions() {
    var gallery = document.querySelector('.sh-gallery-accordions');
    var infoItems = document.querySelector('.sh-info-items');

    if (!gallery || !infoItems) return;

    if (window.innerWidth < 767) {
      if (infoItems.nextElementSibling !== gallery) {
        infoItems.insertAdjacentElement('afterend', gallery);
      }
    }
  }

  moveGalleryAccordions();
  window.addEventListener('resize', moveGalleryAccordions);
});

document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname === '/pages/tecnologia') {
    document.body.classList.add('tecnologia');
  }
});

document.addEventListener('DOMContentLoaded', function () {
  function moveLegalLinks() {
    var legalLinks = document.querySelector('.sh-f-legal-links');
    var linksGrid = document.querySelector('.sh-f-links-grid');

    if (!legalLinks || !linksGrid) return;

    if (window.innerWidth < 767) {
      if (linksGrid.lastElementChild !== legalLinks) {
        linksGrid.appendChild(legalLinks);
      }
    }
  }

  moveLegalLinks();
  window.addEventListener('resize', moveLegalLinks);
});

/* ============================================================
   Galería de miniaturas: carrusel horizontal en ≤767px
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {
  const thumbsWrapEl = document.querySelector('.sh-gallery-thumbs');
  if (!thumbsWrapEl) return;
  const thumbsWrap = /** @type {HTMLElement} */ (thumbsWrapEl);

  if (!document.getElementById('sh-thumbs-carousel-style')) {
    var style = document.createElement('style');
    style.id = 'sh-thumbs-carousel-style';
    style.textContent =
      '.sh-thumbs-carousel{position:relative;}' +
      '.sh-thumbs-arrow{display:none;}' +
      '@media (max-width:767px){' +
        '.sh-gallery-container .sh-gallery-thumbs{' +
          'display:flex;flex-wrap:nowrap;overflow-x:auto;gap:8px;' +
          'scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;' +
          'scrollbar-width:none;padding-bottom:4px;' +
        '}' +
        '.sh-gallery-container .sh-gallery-thumbs::-webkit-scrollbar{display:none;}' +
        '.sh-gallery-container .sh-thumb{flex:0 0 22%;scroll-snap-align:start;}' +
        '.sh-thumbs-arrow{' +
          'display:flex;align-items:center;justify-content:center;' +
          'position:absolute;top:calc(50% - 2px);transform:translateY(-50%);' +
          'width:30px;height:30px;border-radius:50%;' +
          'background:#fff;border:1px solid #e5e7eb;box-shadow:0 2px 6px rgba(0,0,0,.12);' +
          'cursor:pointer;z-index:4;padding:0;transition:opacity .2s;' +
        '}' +
        '.sh-thumbs-prev{left:-2px;}' +
        '.sh-thumbs-next{right:-2px;}' +
        '.sh-thumbs-arrow:disabled{opacity:0;pointer-events:none;}' +
      '}';
    document.head.appendChild(style);
  }

  // Envolver la tira en un contenedor relativo y crear las flechas.
  var parent = thumbsWrap.parentElement;
  if (!parent) return;
  var carousel = document.createElement('div');
  carousel.className = 'sh-thumbs-carousel';
  parent.insertBefore(carousel, thumbsWrap);
  carousel.appendChild(thumbsWrap);

  /**
   * @param {string} cls
   * @param {string} label
   * @param {string} points
   */
  function makeArrow(cls, label, points) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sh-thumbs-arrow ' + cls;
    b.setAttribute('aria-label', label);
    b.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1a1a1a" ' +
      'stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<polyline points="' + points + '"></polyline></svg>';
    return b;
  }
  var prevBtn = makeArrow('sh-thumbs-prev', 'Anterior', '15 18 9 12 15 6');
  var nextBtn = makeArrow('sh-thumbs-next', 'Siguiente', '9 18 15 12 9 6');
  carousel.appendChild(prevBtn);
  carousel.appendChild(nextBtn);

  function scrollAmount() {
    return Math.max(thumbsWrap.clientWidth * 0.75, 80);
  }
  prevBtn.addEventListener('click', function () {
    thumbsWrap.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
  });
  nextBtn.addEventListener('click', function () {
    thumbsWrap.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
  });

  // Oculta la flecha del extremo en el que ya no se puede avanzar.
  function updateArrows() {
    var maxScroll = thumbsWrap.scrollWidth - thumbsWrap.clientWidth;
    prevBtn.disabled = thumbsWrap.scrollLeft <= 1;
    nextBtn.disabled = thumbsWrap.scrollLeft >= maxScroll - 1;
  }
  thumbsWrap.addEventListener('scroll', updateArrows, { passive: true });
  window.addEventListener('resize', updateArrows);
  updateArrows();

  function scrollActiveIntoView() {
    if (window.innerWidth > 767) return;
    var active = thumbsWrap.querySelector('.sh-thumb.is-active');
    if (!active) return;
    var wrapRect = thumbsWrap.getBoundingClientRect();
    var actRect = active.getBoundingClientRect();
    var delta = (actRect.left - wrapRect.left) - (wrapRect.width - actRect.width) / 2;
    thumbsWrap.scrollBy({ left: delta, behavior: 'smooth' });
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m && m.attributeName === 'class') {
        scrollActiveIntoView();
        break;
      }
    }
  });
  observer.observe(thumbsWrap, { attributes: true, attributeFilter: ['class'], subtree: true });
});


